import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconRotate360Left: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="rotate-360-left"><path d="M13.75 13.25L10.75 16.25L13.75 19.25" stroke="currentColor" strokeWidth="1.5"/><path d="M6.875 15.5476C3.81127 14.6399 1.75 12.9432 1.75 11C1.75 8.10051 6.33908 5.75 12 5.75C17.6609 5.75 22.25 8.10051 22.25 11C22.25 13.8995 17.6609 16.25 12 16.25H11" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconRotate360Left;
